module.exports = __webpack_public_path__ + "static/media/plant.10e6d66e.svg";